import { render, staticRenderFns } from "./html/CartItem.html?vue&type=template&id=54c804b4&lang=html&external"
import script from "./js/CartItem.js?vue&type=script&lang=js&external"
export * from "./js/CartItem.js?vue&type=script&lang=js&external"
import style0 from "./scss/CartItem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports